class Signage {
  store;
  id;
  slug;
  account;
  address;
  message;
  name;
  locationId;
  imageUrl;
  localImageUrl;
  orientation;
  alternateLocationIds;
  categories;
  pageSize;
  styleSheet;
  imageSpanPercent ;

  constructor(store, id, slug, account, address, message, name, locationId,localImageUrl, imageUrl, orientation, alternateLocationIds, categories, pageSize, styleSheet, imageSpanPercent:spanPercent ) {
    this.store = store;
    this.id = id;
    this.slug = slug;
    this.account = account;
    this.address = address;
    this.message = message;
    this.name = name;
    this.locationId = locationId;
    this.imageUrl = imageUrl;
    this.localImageUrl = localImageUrl;
    this.orientation = orientation;
    this.alternateLocationIds = alternateLocationIds;
    this.categories = categories;
    this.pageSize = pageSize ? pageSize : 0;
    this.styleSheet = styleSheet ? styleSheet: "small";
    this.imageSpanPercent  = imageSpanPercent  ? imageSpanPercent  : 100;
  }

  static fromJSON(store, json) {
    let { id, urlKey: slug, account, address, message, name, locationId,localImageUrl, imageUrl, orientation, alternateLocations: alternateLocationIds, categories, pageSize, styleSheet, spanPercent:imageSpanPercent} = json;
    localImageUrl = `https://local.afreespace.com:8443/images?url=${encodeURIComponent(imageUrl)}`;

    return new Signage(store, id, slug, account, address, message, name, locationId,localImageUrl, imageUrl, orientation, alternateLocationIds, categories, pageSize, styleSheet, imageSpanPercent );
  }
    }

export default Signage;
